import React, { useState, useEffect } from "react";
import RecoverFormHeader from "./header/RecoverFormHeader";
import RecoverFormStep from "./step/RecoverFormStep";
import { FORM_ERROR } from "final-form";
import { Form as FinalForm, Field } from "react-final-form";
import {
  recoverConfirmation,
  sendVerification,
} from "../../../../app/store/actions/recoverActions";
import {
  combineValidators,
  composeValidators,
  hasLengthBetween,
  isRequired,
  matchesField,
} from "revalidate";
import { Form, Button, Grid, GridColumn, Header } from "semantic-ui-react";
import TextInput from "../../../../app/common/form/TextInput";
import ErrorMessage from "../../../../app/common/form/ErrorMessage";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import RecoverCancel from "./RecoverCancel";
import { metodoVerificacionOptions } from "../../../../app/config/data/options";
import SelectedInput from "../../../../app/common/form/SelectedInput";
import { toast } from "react-toastify";
import {
  normalizeNumero,
  normalizePassword,
} from "../../../../app/util/finalFormUtils";
import { isPasswordImprovedValid } from "../../../../app/util/revalidateUtils";
import {
  CODIGO_METODO_VERIFICACION_PUSH,
  LONGITUD_MAXIMA_CODIGO_VERIFICACION,
  CODIGO_METODO_VERIFICACION_EMAIL,
  LONGITUD_MAXIMA_PASSWORD,
  RECAPTCHA_SITE_KEY,
  TIPO_RECAPTCHA_V3,
} from "../../../../app/infrastructure/appConstants";
import PropTypes from "prop-types";
import { load } from "recaptcha-v3";
import {
  MESSAGE_CODIGO_VERIFICACION_NO_VALIDA,
  MESSAGE_CODIGO_VERIFICACION_REQUERIDO,
} from "../../../../app/util/messageUtils";
import PasswordField from "../../../../app/common/form/PasswordField";
import PasswordConfirmField from "../../../../app/common/form/PasswordConfirmField";

const mapState = (state) => ({
  currentCustomer: state.recoverUser.currentCustomer,
  fase: state.recoverUser.fase,
});

const actions = {
  recoverConfirmation,
  sendVerification,
};

const validate = combineValidators({
  codigoVerificacion: composeValidators(
    isRequired({ message: MESSAGE_CODIGO_VERIFICACION_REQUERIDO }),
    hasLengthBetween(
      LONGITUD_MAXIMA_CODIGO_VERIFICACION,
      LONGITUD_MAXIMA_CODIGO_VERIFICACION
    )({
      message: MESSAGE_CODIGO_VERIFICACION_NO_VALIDA,
    })
  )(),
  password: composeValidators(
    isRequired({ message: "Contraseña es requerido" }),
    isPasswordImprovedValid
  )(),
  confirmPassword: composeValidators(
    isRequired({ message: "La confirmación del contraseña es requerido" }),
    matchesField("password")({ message: "La contraseña no coincide" })
  )(),
});

const RecoverConfirmationForm = ({ currentCustomer, recoverConfirmation }) => {
  const [metodoVerificacion, setMetodoVerificacion] = useState(null);
  const [responseVerificacion, setResponseVerificacion] = useState(null);
  const [
    loadingEnviarCodigoVerificacion,
    setLoadingEnviarCodigoVerificacion,
  ] = useState(false);
  const [disableCodigoVerificacion, setDisableCodigoVerificacion] = useState(
    true
  );
  const [errorMetodoVerificacion, setErrorMetodoVerificacion] = useState({
    show: false,
    message: null,
  });

  const sendCodigoVerificacion = async (e) => {
    e.preventDefault();

    //if (metodoVerificacion) {
    try {

      const data = {
        idValidacion: currentCustomer.idValidacion,
        metodoVerificacion: CODIGO_METODO_VERIFICACION_EMAIL,
      };

      setLoadingEnviarCodigoVerificacion(true);

      const response = await sendVerification(data);

      setResponseVerificacion(response.data);

      toast.success(response && response.message);

      setDisableCodigoVerificacion(false);

      setLoadingEnviarCodigoVerificacion(false);

      setErrorMetodoVerificacion({
        show: false,
        message: null,
      });

    } catch (error) {

      setLoadingEnviarCodigoVerificacion(false);

      setDisableCodigoVerificacion(true);

      setErrorMetodoVerificacion({
        show: true,
        message: error.data.message,
      });
      
    }
    // } else {
    //   setErrorMetodoVerificacion({
    //     show: true,
    //     message: "Selecciona un método de verificación",
    //   });
    // }

  };

  const onChangemetodoVerificacion = (value) => {
    if (value) {
      setMetodoVerificacion(value);
      setErrorMetodoVerificacion({
        show: false,
        message: null,
      });
    }
  };

  //reCAPTCHA
  useEffect(() => {
    load(RECAPTCHA_SITE_KEY).then((recaptcha) => {
      recaptcha.execute().then((token) => {
        console.log("reCAPTCHA load success");
      });
    });
  }, []);

  const updateTokenReCaptcha = async () => {
    const recaptcha = await load(RECAPTCHA_SITE_KEY);
    const token = await recaptcha.execute();
    return token;
  };

  return (
    <FinalForm
      onSubmit={async (values) => {
        const recaptcha = await updateTokenReCaptcha();
        return recoverConfirmation(
          {
            ...values,
            ...responseVerificacion,
            typeReCaptcha: TIPO_RECAPTCHA_V3,
            recaptcha,
          },
          currentCustomer
        ).catch((error) => ({
          [FORM_ERROR]: error,
        }));
      }}
      validate={validate}
      render={({
        handleSubmit,
        submitting,
        submitError,
        invalid,
        pristine,
        dirtySinceLastSubmit,
      }) => (
        <Form onSubmit={handleSubmit} error>
          <br />
          <RecoverFormHeader />
          <RecoverFormStep />
          <Header textAlign="center">
            <Header.Subheader>
              Confirmación y Actualización de contraseña
            </Header.Subheader>
          </Header>
          <Header
            textAlign="center"
            as="h5"
            content={`Cliente: ${currentCustomer &&
              currentCustomer.nombreCliente}`}
            color="blue"
          />
          <br />
          {/* <Field
            name="metodoVerificacion"
            component={SelectedInput}
            placeholder="Selecciona el método de verificación"
            options={metodoVerificacionOptions}
            handleOnChange={onChangemetodoVerificacion}
          />
          {errorMetodoVerificacion.show && (
            <ErrorMessage text={errorMetodoVerificacion.message} />
          )} */}
          <Button
            onClick={sendCodigoVerificacion}
            as={Link}
            to="#"
            fluid
            basic
            color="blue"
            size="small"
            content="Solicitar código de verificación"
            loading={loadingEnviarCodigoVerificacion}
          />
          <br />
          <Header
            textAlign="center"
            as="h5"
            content={`Usuario: ${currentCustomer &&
              currentCustomer.numeroDocumentoCliente}`}
            color="blue"
          />
          <Field
            name="codigoVerificacion"
            component={TextInput}
            placeholder="Ingresa el código de verificación"
            disabled={disableCodigoVerificacion}
            parse={normalizeNumero}
            maxLength={LONGITUD_MAXIMA_CODIGO_VERIFICACION}
          />

          <PasswordField
            name="password"
            placeholder="Ingresa tu contraseña"
            maxLength={64}
          />

          <PasswordConfirmField
            name="confirmPassword"
            placeholder="Confirma tu contraseña"
            maxLength={64}
          />

          {submitError && !dirtySinceLastSubmit && (
            <ErrorMessage error={submitError} />
          )}
          <br />
          <Grid divided="vertically">
            <Grid.Row columns={2}>
              <GridColumn>
                <RecoverCancel />
              </GridColumn>
              <GridColumn>
                <Button
                  fluid
                  disabled={(invalid && !dirtySinceLastSubmit) || pristine}
                  size="large"
                  loading={submitting}
                  color="yellow"
                  content="Aceptar"
                />
              </GridColumn>
            </Grid.Row>
          </Grid>
        </Form>
      )}
    />
  );
};
RecoverConfirmationForm.propTypes = {
  currentCustomer: PropTypes.object.isRequired,
  recoverConfirmation: PropTypes.func.isRequired,
};

export default connect(mapState, actions)(RecoverConfirmationForm);
